/* ============================================================
   MEW — RED OBJECT · theme JS. Vanilla, no dependencies.
   Smart header, drawers, shade switcher, shade finder, demo
   cart, sticky add-to-bag, scroll reveals, count-up stats.
   ============================================================ */

(function () {
  "use strict";
  const $ = (s, c = document) => c.querySelector(s);
  const $$ = (s, c = document) => [...c.querySelectorAll(s)];
  const reduceMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  /* ---------- where things really live ----------
     The static build links to product.html; the storefront does not have one.
     The layout writes the true product and asset paths onto <body>, and every
     link the JS builds is made from them. */
  const body = document.body;
  const productUrl = (body && body.dataset.productUrl) || "/products/mew-lip-glaze";
  const assetBase = (body && body.dataset.assetBase) || "";
  // one spelling of a shade in a link: lowercase, spaces to dashes, so that
  // "Deer Blood" and "deer blood" both arrive as the deer-blood the page reads
  const shadeSlug = name => String(name).trim().toLowerCase().replace(/\s+/g, "-");
  const shadeUrl = name => `${productUrl}?shade=${shadeSlug(name)}`;

  /* ---------- smart header: shadow + hide on scroll down ---------- */
  const header = $(".header");
  if (header) {
    let lastY = window.scrollY;
    const onScroll = () => {
      const y = window.scrollY;
      header.classList.toggle("is-scrolled", y > 24);
      // hide when scrolling down past the hero, reveal on any scroll up
      if (y > lastY && y > window.innerHeight * 0.8) header.classList.add("is-hidden");
      else header.classList.remove("is-hidden");
      lastY = y;
    };
    window.addEventListener("scroll", onScroll, { passive: true });
    onScroll();
  }

  /* ---------- drawers & overlays ---------- */
  const overlay = $(".overlay");
  const closeAll = () => {
    $$(".drawer.is-open").forEach(el => el.classList.remove("is-open"));
    overlay && overlay.classList.remove("is-open");
    document.body.style.overflow = "";
  };
  const openDrawer = sel => {
    const target = $(sel);
    if (!target) return;
    closeAll();
    target.classList.add("is-open");
    overlay && overlay.classList.add("is-open");
    document.body.style.overflow = "hidden";
  };
  $$("[data-open]").forEach(btn => btn.addEventListener("click", e => {
    e.preventDefault();
    openDrawer(btn.dataset.open);
  }));
  $$("[data-close]").forEach(btn => btn.addEventListener("click", closeAll));
  overlay && overlay.addEventListener("click", closeAll);
  document.addEventListener("keydown", e => e.key === "Escape" && closeAll());

  /* ---------- tabs ---------- */
  $$("[data-tabs]").forEach(root => {
    const btns = $$("[data-tab]", root);
    const panels = $$("[data-panel]", root);
    btns.forEach(btn => btn.addEventListener("click", () => {
      btns.forEach(b => b.classList.toggle("is-active", b === btn));
      panels.forEach(p => p.classList.toggle("is-active", p.dataset.panel === btn.dataset.tab));
    }));
  });


  /* ---------- PDP gallery ----------
     The rail drives one viewer. Picking a shade also retargets the first
     thumbnail, so the worn shot always matches the selected variant. */
  $$("[data-gallery]").forEach(root => {
    const main = $("[data-gallery-main]", root);
    const thumbs = $$(".ro-thumb", root);
    if (!main || !thumbs.length) return;
    thumbs.forEach(t => t.addEventListener("click", () => {
      thumbs.forEach(o => {
        const on = o === t;
        o.classList.toggle("is-active", on);
        o.setAttribute("aria-selected", on);
      });
      if (main.src.endsWith(t.dataset.full)) return;
      main.style.opacity = "0";
      setTimeout(() => {
        main.src = t.dataset.full;
        main.alt = t.querySelector("img").alt;
        main.style.opacity = "";
      }, 180);
    }));
  });

  /* ---------- shade switcher ----------
     Any element carrying [data-shade] inside a [data-shadepick] scope becomes
     a variant control. Selecting one updates every [data-shade-name] /
     [data-shade-desc] on the page, swaps [data-shade-hero], and reflects the
     choice in the URL so the shade survives a refresh or a shared link. */
  $$(".shadepick, [data-shadepick]").forEach(group => {
    const btns = $$("[data-shade]", group);
    if (!btns.length) return;
    const hero = $("[data-shade-hero]");

    const select = (btn, push) => {
      const name = btn.dataset.shade;
      // the chosen red travels: every shade control on the page follows,
      // whichever group it lives in (quick-buy swatches, the tab bar…)
      $$("[data-shade]").forEach(b => {
        const on = b.dataset.shade === name;
        b.classList.toggle("is-active", on);
        b.setAttribute("aria-pressed", on);
      });
      const desc = btn.dataset.desc || "";
      $$("[data-shade-name]").forEach(el => (el.textContent = name));
      $$("[data-shade-desc]").forEach(el => (el.textContent = desc));
      // every frame that belongs to a shade follows the choice at once:
      // the worn thumbnail, the object thumbnail, the stage, and the
      // before/after "after" panel all repoint before the fade lands.
      // كل درجة لها صورها الأربع في ملفات الثيم: sh-<key>-lips|tube|swatch|base
      const k = String(name).toLowerCase().includes("deer") ? "deer"
              : ["kiss","velvet","petal","soft"].find(x => String(name).toLowerCase().includes(x)) || "kiss";
      const slots = {
        worn:   btn.dataset.img       || `${assetBase}sh-${k}-lips.jpg`,
        object: btn.dataset.imgObject || `${assetBase}sh-${k}-tube.jpg`,
        lips:   `${assetBase}sh-${k}-lips.jpg`,
        tube:   `${assetBase}sh-${k}-tube.jpg`,
        swatch: `${assetBase}sh-${k}-swatch.jpg`,
        base:   `${assetBase}sh-${k}-base.jpg`,
      };
      $$("[data-shade-slot]").forEach(t => {
        const src = slots[t.dataset.shadeSlot];
        if (!src) return;
        t.dataset.full = src;
        // the slot is either an <img> itself (home stage) or a control
        // wrapping one (PDP thumb)
        const im = t.tagName === "IMG" ? t : t.querySelector("img");
        if (im && im !== hero) im.src = src;
      });
      const firstSlot = $("[data-shade-slot]");
      if (firstSlot) {
        $$(".ro-thumb").forEach(o => {
          const on = o === firstSlot;
          o.classList.toggle("is-active", on);
          o.setAttribute("aria-selected", on);
        });
      }
      // the comparison keeps its own frame unless a shade offers one
      const after = $(".ro-ba__after");
      if (after && btn.dataset.imgAfter) after.src = btn.dataset.imgAfter;
      const note = $("[data-shade-note]");
      if (note && btn.dataset.note) note.textContent = btn.dataset.note;
      $$("[data-shade-link]").forEach(a => {
        a.href = shadeUrl(name);
      });

      // the large stage fades rather than cuts
      if (hero && btn.dataset.img) {
        hero.style.opacity = "0";
        setTimeout(() => {
          hero.src = slots[hero.dataset.shadeSlot] || btn.dataset.img;
          hero.alt = `the lip glaze in ${name}`;
          hero.style.opacity = "";
        }, 160);
      }

      if (push) {
        history.replaceState({}, "", `${location.pathname}?shade=${shadeSlug(name)}`);
      }
    };

    btns.forEach(btn => {
      btn.setAttribute("aria-pressed", btn.classList.contains("is-active"));
      btn.addEventListener("click", () => select(btn, true));
    });

    // honour ?shade= on load, so links from the shop and the finder land right
    const want = new URLSearchParams(location.search).get("shade");
    if (want) {
      const head = v => shadeSlug(v).split("-")[0];
      const match = btns.find(b => shadeSlug(b.dataset.shade) === shadeSlug(want))
                 || btns.find(b => head(b.dataset.shade) === head(want));
      if (match) select(match, false);
    }
  });

  /* ---------- Shopify cart ----------
     The demo counter grows up: add.js / change.js / cart.js.
     The active swatch inside a [data-shadepick] scope decides the
     variant; buttons outside a scope carry their own variant id. */
  const money = cents => {
    const fmt = document.body.dataset.moneyFormat || "AED {{amount}}";
    const n = (cents / 100).toFixed(2).replace(/\.00$/, "");
    return fmt.replace(/{{\s*amount[^}]*}}/, n);
  };
  const cartCountEls = () => $$("[data-cart-count]");

  const renderCart = cart => {
    cartCountEls().forEach(el => (el.textContent = cart.item_count));
    const wrap = $("[data-cart-lines]");
    const foot = $("[data-cart-foot]");
    if (!wrap) return;
    if (!cart.item_count) {
      wrap.innerHTML = '<p class="ro-note">Your bag is empty.</p>';
      foot && (foot.hidden = true);
      return;
    }
    wrap.innerHTML = cart.items.map((it, i) => `
      <div class="cartline">
        <img src="${it.image ? it.image.replace(/(\.[a-z]+)(\?|$)/, "_160x$1$2") : ""}" alt="" width="64" height="80">
        <div class="cartline__info">
          <h4>${it.product_title}</h4>
          ${it.variant_title && !/Default/.test(it.variant_title) ? `<p class="ro-note">${it.variant_title}</p>` : ""}
          <div class="ro-buy__qty" style="margin-top:.4rem">
            <button data-line-qty="-1" data-line="${i + 1}" aria-label="Decrease">−</button>
            <span>${it.quantity}</span>
            <button data-line-qty="1" data-line="${i + 1}" aria-label="Increase">+</button>
          </div>
        </div>
        <b>${money(it.final_line_price)}</b>
      </div>`).join("");
    const total = $("[data-cart-total]");
    total && (total.textContent = money(cart.total_price));
    foot && (foot.hidden = false);
  };

  const refreshCart = () => fetch("/cart.js").then(r => r.json()).then(renderCart);

  $$("[data-add-to-cart]").forEach(btn => {
    btn.addEventListener("click", e => {
      e.preventDefault(); e.stopPropagation();
      const scope = btn.closest("[data-shadepick]");
      const active = scope && $("[data-shade].is-active[data-variant-id]", scope);
      const id = (active && active.dataset.variantId) || btn.dataset.variantId;
      if (!id) return;
      const qtyEl = scope ? $("[data-qty-value]", scope) : $("[data-qty-value]");
      const quantity = qtyEl ? Math.max(1, +qtyEl.textContent) : 1;
      btn.classList.add("is-busy");
      fetch("/cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ id: +id, quantity }),
      })
        .then(r => r.json())
        .then(() => refreshCart())
        .then(() => openDrawer("#cart-drawer"))
        .finally(() => btn.classList.remove("is-busy"));
    });
  });

  document.addEventListener("click", e => {
    const btn = e.target.closest("[data-line-qty]");
    if (!btn) return;
    const row = btn.closest(".cartline");
    const current = +$("span", btn.parentElement).textContent;
    fetch("/cart/change.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ line: +btn.dataset.line, quantity: Math.max(0, current + +btn.dataset.lineQty) }),
    }).then(r => r.json()).then(renderCart);
  });

  $$(".qty").forEach(q => {
    const [minus, plus] = $$("button", q);
    const num = $("span", q);
    minus && minus.addEventListener("click", () => (num.textContent = Math.max(1, +num.textContent - 1)));
    plus && plus.addEventListener("click", () => (num.textContent = +num.textContent + 1));
  });

  /* ---------- sticky add-to-bag ----------
     Mirrors the main button once it scrolls out of view upward, so the
     purchase is always one tap away without ever double-showing. */
  const stickyAtc = $(".sticky-atc");
  const atcAnchor = $("[data-atc-anchor]");
  if (stickyAtc && atcAnchor && "IntersectionObserver" in window) {
    new IntersectionObserver(([e]) => {
      const gone = !e.isIntersecting && e.boundingClientRect.top < 0;
      stickyAtc.classList.toggle("is-in", gone);
    }, { threshold: 0 }).observe(atcAnchor);
  }


  /* every picture frame joins the reveal system, so the curtain-and-settle
     treatment applies site-wide without touching a single template */
  $$(".ro-card__media, .ro-split__media, .ro-pcard__media, .ro-post__media, " +
     ".ro-quote__media, .ro-fcard__media, .ro-formula__still, .ro-shade__media, " +
     ".ro-pdp__frame, .ro-menu__promo img").forEach(el => el.classList.add("reveal-img"));

  /* ---------- scroll reveal with stagger ----------
     IntersectionObserver + rAF scroll fallback (some engines
     throttle IO) — whichever fires first wins. */
  if (reduceMotion) {
    $$(".reveal, .reveal-img").forEach(el => el.classList.add("is-in"));
  } else {
    // auto-stagger children of [data-stagger] containers
    $$("[data-stagger]").forEach(parent => {
      $$(":scope > .reveal, :scope > * > .reveal", parent).forEach((el, n) => {
        el.style.setProperty("--reveal-delay", `${Math.min(n * 70, 420)}ms`);
      });
    });
    const pending = new Set($$(".reveal, .reveal-img"));
    const show = el => { el.classList.add("is-in"); pending.delete(el); };
    if ("IntersectionObserver" in window) {
      const io = new IntersectionObserver(entries => {
        entries.forEach(e => {
          if (e.isIntersecting) { show(e.target); io.unobserve(e.target); }
        });
      }, { threshold: 0.1, rootMargin: "0px 0px -5% 0px" });
      pending.forEach(el => io.observe(el));
    }
    const sweep = () => {
      if (!pending.size) return;
      const vh = window.innerHeight;
      pending.forEach(el => {
        const r = el.getBoundingClientRect();
        if (r.top < vh * 0.94 && r.bottom > 0) show(el);
      });
    };
    let sweepTick = false;
    window.addEventListener("scroll", () => {
      if (sweepTick) return;
      sweepTick = true;
      requestAnimationFrame(() => { sweepTick = false; sweep(); });
    }, { passive: true });
    window.addEventListener("resize", sweep, { passive: true });
    sweep();
  }

  /* ---------- parallax (subtle, rAF-throttled) ---------- */
  const pxEls = $$("[data-parallax]");
  if (pxEls.length && !reduceMotion) {
    let ticking = false;
    const apply = () => {
      ticking = false;
      const vh = window.innerHeight;
      pxEls.forEach(el => {
        const r = el.getBoundingClientRect();
        if (r.bottom < 0 || r.top > vh) return;
        const progress = (r.top + r.height / 2 - vh / 2) / (vh / 2 + r.height / 2); // -1..1
        const depth = parseFloat(el.dataset.parallax) || 6;
        const media = el.querySelector(".ph--fill, .im--fill");
        if (media) media.style.transform = `translateY(${(-progress * depth).toFixed(2)}%)`;
      });
    };
    window.addEventListener("scroll", () => {
      if (!ticking) { ticking = true; requestAnimationFrame(apply); }
    }, { passive: true });
    apply();
  }

  /* ---------- count-up stats ---------- */
  if ("IntersectionObserver" in window) {
    $$(".stat b").forEach(el => {
      const m = el.textContent.match(/^([^0-9]*)([\d,]+)(.*)$/);
      if (!m) return;
      const target = parseInt(m[2].replace(/,/g, ""), 10);
      if (!target || reduceMotion) return;
      const io = new IntersectionObserver(([entry]) => {
        if (!entry.isIntersecting) return;
        io.disconnect();
        const t0 = performance.now(), dur = 1400;
        const tick = now => {
          const p = Math.min((now - t0) / dur, 1);
          const eased = 1 - Math.pow(1 - p, 4);
          el.textContent = m[1] + Math.round(target * eased).toLocaleString() + m[3];
          if (p < 1) requestAnimationFrame(tick);
        };
        requestAnimationFrame(tick);
      }, { threshold: 0.5 });
      io.observe(el);
    });
  }

  /* ---------- red-object home page ----------
     Scoped to .ro — every block below no-ops on the other pages. */
  if ($(".ro")) {
    // FAQ accordion (two-column, one open at a time per column is not enforced)
    $$(".ro-faq__q").forEach(q => {
      q.addEventListener("click", () => q.closest(".ro-faq__item").classList.toggle("is-open"));
    });

    // quantity stepper
    $$("[data-qty-value]").forEach(out => {
      const box = out.closest(".ro-buy__qty");
      $$("[data-qty]", box).forEach(btn => btn.addEventListener("click", () => {
        const next = Math.max(1, parseInt(out.textContent, 10) + parseInt(btn.dataset.qty, 10));
        out.textContent = next;
      }));
    });

    // shade finder — three answers score the five shades, highest total wins
    const quiz = $("[data-quiz]");
    if (quiz) {
      const SHADES = {
        kiss:   { name: "Kiss",       img: "shade-kiss.jpg",   tube: "tube-kiss-cut.png",
                  note: "The deepest of the shades: a red that leans cherry." },
        deer:   { name: "Deer Blood", img: "shade-deer.jpg",   tube: "tube-deer-cut.png",
                  note: "The middle shade: a red that leans strawberry, and it suits most skin tones." },
        velvet: { name: "Velvet",     img: "shade-velvet.jpg", tube: "tube-velvet-cut.png",
                  note: "A light pink like the Taif rose, and it lifts the face in daylight." },
        petal:  { name: "Petal",      img: "shade-petal.jpg",  tube: "tube-petal-cut.png",
                  note: "Close to the colour of a peach, with or without the rest of the makeup." },
        soft:   { name: "Soft",       img: "shade-soft.jpg",   tube: "tube-soft-cut.png",
                  note: "A nude close to your own lip, for every day." },
      };
      const SCORE = {
        deep:  { kiss: 3, deer: 2 },              mid:    { deer: 3, velvet: 1, petal: 1 },
        sheer: { soft: 3, petal: 2 },
        // لون البشرة: بيضاء / حنطية / سمراء
        fair:  { velvet: 2, petal: 1, kiss: 1 },  wheat:  { deer: 2, petal: 1, velvet: 1 },
        bronze:{ kiss: 2, deer: 1, soft: 1 },
        night: { kiss: 2, deer: 1 },              day:    { velvet: 2, petal: 1 },
        always:{ soft: 2, petal: 1 },
      };
      const steps = $$(".ro-quiz__step", quiz);
      const dots = $$(".ro-quiz__progress span", quiz);
      let tally = {};

      const show = i => {
        steps.forEach((s, n) => s.classList.toggle("is-active", n === i));
        dots.forEach((d, n) => d.classList.toggle("is-active", n <= i));
        quiz.scrollIntoView({ block: "center", behavior: "smooth" });
      };

      $$(".ro-quiz__opt", quiz).forEach(btn => btn.addEventListener("click", () => {
        const points = SCORE[btn.dataset.quizAnswer] || {};
        Object.entries(points).forEach(([k, v]) => (tally[k] = (tally[k] || 0) + v));
        const here = steps.indexOf(btn.closest(".ro-quiz__step"));
        if (here < steps.length - 2) return show(here + 1);

        const won = Object.keys(SHADES).reduce((a, b) => ((tally[b] || 0) > (tally[a] || 0) ? b : a), "kiss");
        const s = SHADES[won];
        const set = (sel, fn) => { const el = $(sel, quiz); if (el) fn(el); };
        set("[data-quiz-result-name]", el => (el.textContent = s.name));
        set("[data-quiz-result-note]", el => (el.textContent = s.note));
        set("[data-quiz-result-img]",  el => (el.src = assetBase + s.img));
        set("[data-quiz-result-tube]", el => (el.src = assetBase + s.tube));
        set(".ro-quiz__step[data-quiz-step='result'] .ro__btn",
            el => (el.href = shadeUrl(s.name)));
        show(steps.length - 1);
      }));

      const restart = $("[data-quiz-restart]", quiz);
      restart && restart.addEventListener("click", () => { tally = {}; show(0); });
    }

  }


  /* ---------- before / after ----------
     Pointer, keyboard and touch all drive one --split variable. */
  $$("[data-compare]").forEach(box => {
    const handle = $(".ro-ba__handle", box);
    if (!handle) return;
    const set = pct => {
      const v = Math.max(0, Math.min(100, pct));
      box.style.setProperty("--split", v + "%");
      handle.setAttribute("aria-valuenow", Math.round(v));
    };
    const fromEvent = e => {
      const r = box.getBoundingClientRect();
      set(((e.clientX - r.left) / r.width) * 100);
    };
    let dragging = false;
    const start = e => {
      dragging = true;
      try { box.setPointerCapture(e.pointerId); } catch { /* synthetic pointer */ }
      fromEvent(e);
    };
    const move  = e => { if (dragging) fromEvent(e); };
    const stop  = () => { dragging = false; };
    box.addEventListener("pointerdown", start);
    box.addEventListener("pointermove", move);
    window.addEventListener("pointerup", stop);
    handle.addEventListener("keydown", e => {
      const now = parseFloat(handle.getAttribute("aria-valuenow")) || 50;
      if (e.key === "ArrowLeft")  { e.preventDefault(); set(now - 4); }
      if (e.key === "ArrowRight") { e.preventDefault(); set(now + 4); }
    });
    set(50);
  });

  /* ---------- footer year + demo forms ---------- */
  $$("[data-year]").forEach(el => (el.textContent = new Date().getFullYear()));
  $$("form[data-demo]").forEach(f => f.addEventListener("submit", e => {
    e.preventDefault();
    const btn = f.querySelector("button[type=submit], .btn");
    if (btn) {
      const orig = btn.textContent;
      btn.textContent = "✓ done";
      setTimeout(() => (btn.textContent = orig), 1800);
    }
  }));
  /* ---------- headings arrive line by line ----------
     Each line is wrapped so it can rise from behind its own mask.
     Reduced motion skips the wrapping entirely. */
  if (!reduceMotion && "IntersectionObserver" in window) {
    const heads = $$("h1, h2").filter(h => !h.closest(".ro-header, .ro-footer, .drawer") && h.children.length <= 2);
    const io = new IntersectionObserver(entries => {
      entries.forEach(e => { if (e.isIntersecting) { e.target.classList.add("is-in"); io.unobserve(e.target); } });
    }, { threshold: .25, rootMargin: "0px 0px -8% 0px" });
    // On a phone a two-word heading has no business standing in two blocks,
    // so the authored line breaks collapse and the whole heading rises as one.
    const narrow = window.matchMedia("(max-width: 860px)").matches;
    heads.forEach(h => {
      const lines = narrow
        ? [h.innerHTML.replace(/<br\s*\/?>/gi, " ")]
        : h.innerHTML.split(/<br\s*\/?>/i);
      if (lines.length > 3) return;
      h.innerHTML = lines.map(l => `<span class="reveal-line"><span>${l}</span></span>`).join("");
      $$(".reveal-line", h).forEach((l, i) => {
        l.style.setProperty("--reveal-delay", (i * 60) + "ms");
        io.observe(l);
      });
    });
  }




  /* ---------- panels that open on a press ----------
     Height is animated from a measured value so the panel can be
     interrupted mid-flight, and it settles on auto. */
  $$("[data-acc]").forEach(root => {
    const items = $$(".ro-acc__item", root);
    items.forEach(item => {
      const q = $(".ro-acc__q", item), a = $(".ro-acc__a", item);
      if (!q || !a) return;
      q.setAttribute("aria-expanded", "false");
      const close = () => { a.style.height = a.scrollHeight + "px"; requestAnimationFrame(() => { a.style.height = "0px"; }); q.setAttribute("aria-expanded", "false"); };
      const open = () => {
        a.style.height = a.scrollHeight + "px";
        q.setAttribute("aria-expanded", "true");
        a.addEventListener("transitionend", function done(e) {
          if (e.propertyName !== "height") return;
          if (q.getAttribute("aria-expanded") === "true") a.style.height = "auto";
          a.removeEventListener("transitionend", done);
        });
      };
      q.addEventListener("click", () => {
        const isOpen = q.getAttribute("aria-expanded") === "true";
        if (root.dataset.acc === "one") items.forEach(o => {
          const oq = $(".ro-acc__q", o), oa = $(".ro-acc__a", o);
          if (oq !== q && oq.getAttribute("aria-expanded") === "true") {
            oa.style.height = oa.scrollHeight + "px";
            requestAnimationFrame(() => { oa.style.height = "0px"; });
            oq.setAttribute("aria-expanded", "false");
          }
        });
        isOpen ? close() : open();
      });
    });
  });

  /* ---------- the reading line ---------- */
  (() => {
    if (!$(".ro-progress")) {
      const bar = document.createElement("div");
      bar.className = "ro-progress";
      bar.innerHTML = "<i></i>";
      document.body.appendChild(bar);
    }
    const fill = $(".ro-progress i");
    if (!fill) return;
    const run = () => {
      const h = document.documentElement.scrollHeight - window.innerHeight;
      fill.style.transform = `scaleX(${h > 0 ? Math.min(1, window.scrollY / h) : 0})`;
    };
    window.addEventListener("scroll", run, { passive: true });
    window.addEventListener("resize", run);
    run();
  })();

  /* ---------- the jump rail follows the page ---------- */
  (() => {
    const links = $$(".ro-jump a");
    if (!links.length || !("IntersectionObserver" in window)) return;
    const map = new Map();
    links.forEach(a => {
      const el = document.getElementById(a.getAttribute("href").slice(1));
      if (el) map.set(el, a);
    });
    const io = new IntersectionObserver(entries => {
      entries.forEach(e => {
        if (!e.isIntersecting) return;
        links.forEach(l => l.classList.remove("is-here"));
        map.get(e.target).classList.add("is-here");
      });
    }, { rootMargin: "-30% 0px -60% 0px" });
    map.forEach((_, el) => io.observe(el));
  })();

  /* ---------- the gallery counts its frames ---------- */
  $$("[data-gallery]").forEach(root => {
    const stage = $(".ro-gallery__stage", root);
    const thumbs = $$(".ro-thumb", root);
    if (!stage || thumbs.length < 2 || $(".ro-gallery__counter", stage)) return;
    const el = document.createElement("span");
    el.className = "ro-gallery__counter";
    el.innerHTML = `<b>01</b><span>/ ${String(thumbs.length).padStart(2, "0")}</span>`;
    stage.appendChild(el);
    thumbs.forEach((t, i) => t.addEventListener("click", () => {
      $("b", el).textContent = String(i + 1).padStart(2, "0");
    }));
  });

  /* ---------- the plate deck ----------
     Arrows, a counter and a rail that tracks the scroll. The deck is a
     native scroller, so a thumb still owns it. */
  $$("[data-plates]").forEach(root => {
    const track = $("[data-plate-track]", root);
    const slides = $$(".ro-plates__slide", track);
    const now = $("[data-plate-now]", root), all = $("[data-plate-all]", root);
    const bar = $("[data-plate-bar]", root);
    if (!track || !slides.length) return;
    const pad = n => String(n).padStart(2, "0");
    all && (all.textContent = pad(slides.length));
    const sync = () => {
      const i = Math.round(track.scrollLeft / (slides[0].offsetWidth + 14));
      const idx = Math.min(slides.length - 1, Math.max(0, i));
      now && (now.textContent = pad(idx + 1));
      if (bar) {
        const per = 100 / slides.length;
        bar.style.width = per + "%";
        bar.style.transform = `translateX(${idx * 100}%)`;
      }
      $$("[data-plate]", root).forEach(b => {
        const dir = +b.dataset.plate;
        b.disabled = (dir < 0 && idx === 0) || (dir > 0 && idx >= slides.length - 1);
      });
    };
    track.addEventListener("scroll", () => requestAnimationFrame(sync), { passive: true });
    $$("[data-plate]", root).forEach(b => b.addEventListener("click", () => {
      const step = slides[0].offsetWidth + 14;
      track.scrollBy({ left: step * +b.dataset.plate, behavior: reduceMotion ? "auto" : "smooth" });
    }));
    sync();
  });

  /* ---------- 01 · depth ladder ----------
     Five steps on one scale. Hovering or tapping a step reads it out
     below, so the comparison is felt before it is read. */
  $$("[data-ladder]").forEach(root => {
    const steps = $$(".ro-ladder__step", root);
    const read = $(".ro-ladder__read", root);
    if (!steps.length || !read) return;
    const show = el => {
      steps.forEach(s => s.classList.toggle("is-active", s === el));
      read.innerHTML = `<b>${el.dataset.name}</b> — ${el.dataset.read}`.replace(" — ", ". ");
    };
    steps.forEach(el => {
      el.addEventListener("mouseenter", () => show(el));
      el.addEventListener("focus", () => show(el));
      el.addEventListener("click", () => show(el));
    });
    show(steps[0]);
  });

  /* ---------- 09 · pinned sequence ----------
     The object stays; its readings advance. One pin for the whole site. */
  const pin = $("[data-pin]");
  if (pin && "IntersectionObserver" in window) {
    const steps = $$(".ro-pin__step", pin);
    const io = new IntersectionObserver(entries => {
      entries.forEach(e => {
        if (!e.isIntersecting) return;
        steps.forEach(s => s.classList.toggle("is-on", s === e.target));
        const src = e.target.dataset.pinImg;
        const img = $(".ro-pin__media .ro__img", pin);
        if (src && img && !img.src.endsWith(src)) {
          img.style.opacity = "0";
          setTimeout(() => { img.src = src; img.style.opacity = ""; }, 180);
        }
      });
    }, { rootMargin: "-45% 0px -45% 0px" });
    steps.forEach(s => io.observe(s));
    steps[0] && steps[0].classList.add("is-on");
  }

  /* ---------- 15 · the standing number ----------
     Counts up once, on arrival. Reduced motion gets the final value. */
  $$("[data-count]").forEach(el => {
    const target = el.dataset.count;
    const pad = target.length;
    const end = parseInt(target, 10);
    if (reduceMotion || !("IntersectionObserver" in window) || isNaN(end)) { el.textContent = target; return; }
    el.textContent = "".padStart(pad, "0");
    const io = new IntersectionObserver(([e]) => {
      if (!e.isIntersecting) return;
      io.disconnect();
      const t0 = performance.now(), dur = 1100;
      const tick = now => {
        const p = Math.min(1, (now - t0) / dur);
        const eased = 1 - Math.pow(1 - p, 3);
        el.textContent = String(Math.round(end * eased)).padStart(pad, "0");
        if (p < 1) requestAnimationFrame(tick);
      };
      requestAnimationFrame(tick);
    }, { threshold: .4 });
    io.observe(el);
  });

  /* ---------- Shopify theme editor ---------- */
  document.addEventListener("shopify:section:load", () => {
    $$(".reveal:not(.is-in)").forEach(el => el.classList.add("is-in"));
  });
})();
